import { BlockType } from '@next-space/fe-api-idl';
import { fromEvent } from 'file-selector';
import { useCallback } from 'react';
import { getCurrentSpaceId } from 'src/hooks/space/get-space';
import { useUpload, useUploadDriveFiles } from 'src/hooks/space/use-upload';
import { useTransaction } from 'src/hooks/use-transaction';
import { cache } from 'src/redux/store';
import { getDropInfo, reSetDropInfo } from 'src/services/app/hook/use-drop-info';
import { $currentUserCache } from 'src/services/user/current-user';
import { getDynamicPageId } from 'src/utils/getPageId';
import isURL from 'validator/lib/isURL';
import { pasteHTML } from '../use-copy-listener/on-paste/paste-html';
import { pasteLink } from '../use-copy-listener/on-paste/paste-link';
import { pastePlain } from '../use-copy-listener/on-paste/paste-plain';
import { useSelectedBlockHistory } from '../use-selected-block-history';
import { isAsideArea } from './helper';
import type { DropInfo } from './types';
import { DRIVE } from './types';

export const useOnDropFile = () => {
  const transaction = useTransaction();
  const uploadFile = useUpload();
  const { selectedBlockHistory } = useSelectedBlockHistory();

  const uploadDriveFile = useUploadDriveFiles();

  const onDrop = async (event: DragEvent) => {
    const dropInfo = getDropInfo();

    if (!dropInfo) return;
    const fileList = event.dataTransfer?.files;
    const items = event.dataTransfer?.items;
    reSetDropInfo();
    const { cursorArea, dropId, position } = dropInfo;

    if (fileList && fileList.length) {
      const pageId = getDynamicPageId();
      const upload = (files: any, params?: DropInfo) => {
        void uploadDriveFile(
          {
            ownerPageId: pageId,
            files: files as any[],
            spaceId: getCurrentSpaceId(),
            userId: $currentUserCache.uuid,
            type: 'file',
            inTransferList: true,
            onComplete: () => {},
          },
          params
        );
      };

      if (cursorArea === DRIVE.ALL) {
        void fromEvent(event).then((files) => upload(files));
      } else if (!isAsideArea(cursorArea)) {
        // fix：拖拽文件上传至多维表，会多创建一条记录
        // 空页面 或 多维表页面最下面 时 dropId 为空
        if (dropId && !position) return;
        if (!dropId) {
          const page = cache.blocks[pageId];
          if (page && page.type !== BlockType.PAGE) return;
        }

        void fromEvent(event).then((files) => {
          upload(files, { dropId, position });
        });
      }
    } else if (items) {
      for (const item of items) {
        const data = event.dataTransfer.getData(item.type);

        if (item.kind === 'string') {
          if (isURL(data)) {
            void pasteLink({ transaction, uploadFile }, event, data);
            break;
          }

          if (item.type === 'text/html') {
            void pasteHTML({ transaction, selectedBlockHistory }, data);
            break;
          }

          pastePlain({ transaction, selectedBlockHistory }, data);
          break;
        }
      }
    }
  };

  return useCallback(onDrop, [selectedBlockHistory, transaction, uploadDriveFile, uploadFile]);
};
